import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: false,
    cache:true
};
const noCacheMeta = {
    auth: false
};

export default {
    path: '/sys',
    name: 'sys',
    redirect: {
        name: 'sysLanguageList'
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: '/sys/sysLanguage/sysLanguageEdit/:id',
            name: 'sysLanguageEdit',
            meta: {
                ...meta,
                title: '$t:menu.sysLanguageEdit',
                desc: '语言编辑'
            },
            component: () => import('@/pages/sys/sysLanguage/sysLanguageEdit.vue')
        },
        {
        	path: '/sys/sysLanguage/sysLanguageList',
        	name: 'sysLanguageList',
        	meta: {
        		...meta,
        		title: '$t:menu.sysLanguageList',
                desc: '语言管理'
        	},
        	component: () => import('@/pages/sys/sysLanguage/sysLanguageList.vue')
        },
        {
            path: '/sys/sysLanguage/sysLanguageEdit',
            name: 'sysLanguageAdd',
            meta: {
                ...meta,
                title: '新增语言'
            },
            component: () => import('@/pages/sys/sysLanguage/sysLanguageEdit.vue')
        },
        {
            path: '/sys/sysInternation/sysInternationEdit/:id',
            name: 'sysInternationEdit',
            meta: {
                //...noCacheMeta,
                ...meta,
                title: '$t:menu.sysInternationEdit',
                desc: '翻译编辑'
            },
            component: () => import('@/pages/sys/sysInternation/sysInternationEdit.vue')
        },
        {
        	path: '/sys/sysInternation/sysInternationList',
        	name: 'sysInternationList',
        	meta: {
        		 //...noCacheMeta,
        		 ...meta,
        		title: '$t:menu.sysInternationList',
				desc: '翻译管理'
        	},
        	component: () => import('@/pages/sys/sysInternation/sysInternationList.vue')
        },

        {
        	path: '/sys/emailTempList',
        	name: 'sysEmailTempList',
        	meta: {
        		 //...noCacheMeta,
        		 ...meta,
        		title: '$t:menu.sysEmailTempList',
				desc: '邮件模板'
        	},
        	component: () => import('@/pages/sys/sysEmailTemp/sysEmailTempList.vue')
        },
        {
        	path: '/sys/pageAuthConfigList',
        	name: 'sysConfigureList',
        	meta: {
        		 //...noCacheMeta,
        		 ...meta,
        		title: '$t:menu.pageAuthConfig',
				desc: '页面权限配置'
        	},
        	component: () => import('@/pages/sys/sysConfigure/sysConfigureList.vue')
        },
        {
        	path: '/sys/sysFileTempList',
        	name: 'sysFileTempList',
        	meta: {
        		 //...noCacheMeta,
        		 ...meta,
        		title: '$t:menu.sysFileTempList',
				desc: '文件模板'
        	},
        	component: () => import('@/pages/sys/sysFileTemp/sysFileTempList.vue')
        },

    ]
};
